import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 0 1 7.794 13.5l-7.79 -4.497v-9","fill":"currentColor","stroke":"none","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconPercentage33 = createReactComponent('outline', 'percentage-33', 'Percentage33', __iconNode);

export default IconPercentage33;